import React, { useEffect, useState } from 'react';
import '../../styles/Testimonials.css';
import testimonial1 from '../../images/testimonial-1.jpg'
import testimonial2 from '../../images/testimonial-2.jpg'
import testimonial3 from '../../images/testimonial-3.jpg'

const testimonials = [
  {
    name: "Aarav Patil",
    course: "BSc Computer Science",
    quote: "The placement training and mentorship helped me crack multiple interviews. Forever grateful to our college!",
    company: "Placed at Infosys",
    image: testimonial1,
    rating: 5,
  },
  {
    name: "Sneha Joshi",
    course: "BSc Computer Science",
    quote: "Great faculty and hands-on learning. The environment really shaped my career path.",
    company: "Placed at TCS",
    image: testimonial2,
    rating: 4,
  },
  {
    name: "Raj Kulkarni",
    course: "BSc Computer Science",
    quote: "Amazing experience! The support from the placement cell made all the difference.",
    company: "Placed at Wipro",
    image: testimonial3,
    rating: 5,
  },
  {
    name: "Priya Deshmukh",
    course: "BSc Computer Science",
    quote: "From soft skills to interview prep, the journey here was transformative.",
    company: "Placed at Capgemini",
    image: testimonial3,
    rating: 4,
  }
];

const Testimonial = () => {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const cardsPerSlide = window.innerWidth >= 768 ? 2 : 1;
  const totalSlides = Math.ceil(testimonials.length / cardsPerSlide);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 5000);

    return () => clearInterval(interval);
  }, [cardsPerSlide, totalSlides]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const getVisibleTestimonials = () => {
    const start = currentIndex * cardsPerSlide;
    return testimonials.slice(start, start + cardsPerSlide);
  };

  return (
    <section className="section-container">
    <section className={`testimonial-section ${visible ? 'fade-in' : ''}`}>
      <h4 className="college-name-testomonials">SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ</h4>
      <h2 className="heading">What Our Students Say</h2>
      <p className="subheading">Hear from our alumni placed in top companies</p>

      <div className="testimonial-wrapper">
        {getVisibleTestimonials().map((t, i) => (
          <div className="testimonial-card" key={i}>
            <img src={t.image} alt={t.name} className="testimonial-img" />
            <p className="quote">“{t.quote}”</p>
            <div className="student-info">
              <h3>{t.name}</h3>
              <p className="course">{t.course}</p>
              <p className="company">{t.company}</p>
              <div className="stars">
                {'★'.repeat(t.rating)}{'☆'.repeat(5 - t.rating)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="testimonial-nav">
        <button className="nav-btn left" onClick={goPrev}>‹</button>
        <button className="nav-btn right" onClick={goNext}>›</button>
      </div>

      <div className="testimonial-dots">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </section>
    </section>
  );
};

export default Testimonial;
